import React from 'react';
import classnames from 'classnames';
import LinkButton from 'components/uiLibrary/LinkButton';
import EntityName from 'components/Globals/EntityName';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';
import { ENTITY_TYPES } from 'operabase-router/constants';
import usePageContext from 'utils/hooks/usePageContext';
import { trackingData } from '../constants';
import classes from './ProductionInfo.module.scss';

/**
 * Scenarios:
 * 1. Multiple Works
 *      Show always Custom Title even if its empty
 * 2. Single Work
 *      If Custom Title Exists and is same as Work Name
 *      OR Custom Title is empty
 *          Show Work using EntityName
 *      Else
 *          Show Custom Title
 *
 */

const WorkTitle = ({ title, works, styles, renderAsLink }) => {
  const { navigate } = usePageContext();

  if (title) {
    return (
      <Typography
        size={16}
        color="primary"
        weight="bold"
        className={classnames(classes.workTitleContainer, classes.workTitle)}
      >
        {title}
      </Typography>
    );
  }

  if (!works?.[0]) {
    return null;
  }

  const workLinkProps = renderAsLink
    ? navigate.getLinkProps({
        entity: works[0],
        entityType: ENTITY_TYPES.WORK,
      })
    : {};

  return (
    <span className={classnames(classes.workTitleContainer, { [styles?.containerRoot]: !!styles?.containerRoot })}>
      <LinkButton
        styles={{ root: classes.workItemLink }}
        variant="native"
        target="_blank"
        {...workLinkProps}
        isLink
        trackingData={{
          ...trackingData,
          entityId: works[0].id,
          entityName: works[0].name,
          entityType: ENTITY_TYPES.WORK,
        }}
      >
        <>
          <EntityName
            entity={works[0]}
            entityType={ENTITY_TYPES.WORK}
            trackingData={trackingData}
            typographyProps={{
              work: {
                weight: 'bold',
                color: renderAsLink ? 'link' : undefined,
                className: classnames(classes.workTitle, { [styles?.workTitle]: !!styles?.workTitle }),
                size: 16,
              },
              translation: {
                size: 16,
                className: classes.workTranslation,
              },
              composer: {
                size: 16,
                color: 'primary',
                className: classes.composer,
              },
            }}
            onlyShortName
            withComposers
          />
          {renderAsLink && <SpriteIcon icon="open_in_new" size={16} className={classes.openInNewTabIcon} />}
        </>
      </LinkButton>
    </span>
  );
};

export default WorkTitle;
